import React, { useState } from 'react'
import { toast } from '@CommonComponents/toast'
import { LoadingSpinner, MEModal } from '@CommonComponents'
import { Button } from 'react-bootstrap'
import { client } from '@Utils'
import { useStateValue } from '@State'
import { history } from './App'

export const Achievement = ({ itemId, acmtType, name, requiredScores }) => {
  const [currentState, dispatch] = useStateValue()
  const [showActs, toggleActs] = useState(false)
  const [modalOpen, toggleModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleDelete = async itemId => {
    setIsLoading(true)
    try {
      await client.delete(
        `/instructor/achievements.delete_achievement/${itemId}`
      )
      if (acmtType === 'certificate') {
        let newCerts = currentState.certificates.filter(
          cert => cert.id !== itemId
        )
        dispatch({ type: 'updateCerts', payload: newCerts })
      } else {
        let newBadges = currentState.badges.filter(badge => badge.id !== itemId)
        dispatch({ type: 'updateBadges', payload: newBadges })
      }
    } catch (err) {
      let errMsg = err.response.data.msg
      toast.error(errMsg)
    }
    setIsLoading(false)
  }

  return (
    <React.Fragment>
      <div className="d-flex">
        <div className="w-75 d-flex align-items-center">
          <i
            className={`fa-light fa-chevron-${
              showActs ? 'down' : 'right'
            } pointer mr-4 fa-lg`}
            onClick={() => toggleActs(!showActs)}
          />
          <span className="align-self-center">{name}</span>
        </div>
        <div className="d-flex justify-content-end w-25">
          <button
            className="btn btn-myed btn-default btn-default-myed btn-sm-myed mr-2"
            onClick={() =>
              history.push(
                `/instructor/achievements/${currentState.coursenum}/${itemId}/${acmtType}/edit`
              )
            }
          >
            <i className="fa-regular fa-edit mr-2" />
            Edit
          </button>
          <button
            className="btn btn-myed btn-default btn-default-myed btn-sm-myed text-danger"
            onClick={() => toggleModal(true)}
          >
            <i className="fa-regular fa-trash mr-2" />
            Delete
          </button>
        </div>
        <MEModal
          show={modalOpen}
          close={() => toggleModal(false)}
          title={`Delete ${acmtType}`}
        >
          <React.Fragment>
            <p>Are you sure you want to delete this {acmtType}?</p>
            <div className="d-flex justify-content-center">
              <span className="mt-3">
                <Button
                  className="btn-myed btn-default-myed mr-3"
                  type="button"
                  variant="secondary"
                  onClick={() => toggleModal(false)}
                >
                  <i className="fa-regular fa-times mr-2" />
                  Cancel
                </Button>
                <Button
                  className="btn-myed btn-danger-myed"
                  type="button"
                  variant="danger"
                  onClick={() => handleDelete(itemId)}
                  disabled={isLoading}
                >
                  <div className="d-flex align-items-center">
                    {isLoading ? (
                      <LoadingSpinner
                        className="align-self-center"
                        style={{
                          fontSize: '15px',
                          color: 'white',
                          marginRight: '4px',
                        }}
                      />
                    ) : (
                      <i className="fa-regular fa-trash mr-2" />
                    )}
                    <span>{isLoading ? 'Deleting' : 'Delete'}</span>
                  </div>
                </Button>
              </span>
            </div>
          </React.Fragment>
        </MEModal>
      </div>
      {showActs && (
        <div>
          {requiredScores.length > 0 ? (
            <React.Fragment>
              <table className="table table-bordered w-75 ml-5 mt-3">
                <thead>
                  <tr>
                    <th className="pl-3" scope="col">
                      Assessment Name
                    </th>
                    <th className="pl-3" scope="col">
                      Required Score
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {requiredScores.map((score, i) => (
                    <tr key={i}>
                      <td className="pl-3">{score.name}</td>
                      <td className="pl-3">{score.score}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </React.Fragment>
          ) : (
            <p className="ml-5">
              <i>
                No requirements have been created. This {acmtType} will not be
                awarded.
              </i>
            </p>
          )}
        </div>
      )}
    </React.Fragment>
  )
}
